import React, { useState } from "react";
import {
  useAddTodoMutation,
  useDeleteTodoMutation,
  useGetTodosQuery,
  useUpdateStatusTodoMutation,
} from "../features/api/apiSlice";
import tick from "../images/double-tick.png";
import note from "../images/notes.png";
import plus from "../images/plus.png";
export default function Header() {
  const { data: todos, isLoading } = useGetTodosQuery();
  const [addTodo, { error }] = useAddTodoMutation();
  const [deleteTodo, { isLoading: deletingTodo }] = useDeleteTodoMutation();
  const [updateStatusTodo, { isLoading: updatingStatus }] =
    useUpdateStatusTodoMutation();
  const [input, setInput] = useState("");
  if (isLoading || updatingStatus) {
    return "Loading...";
  }
  if (deletingTodo) {
    return "Deleting...";
  }
  if (error) {
    window.alert(error?.message);
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === "") {
      return window.alert("Please enter something.");
    }
    addTodo({
      text: input,
      completed: false,
      color: "",
    });
    setInput("");
  };
  // to update all the todos are completed
  const handleCompleteAllTasks = () => {
    todos.map((todo) => {
      if (!todo.completed) {
        const id = todo.id;
        const data = {
          completed: true,
        };
        updateStatusTodo({
          id,
          data,
        });
      }
    });
  };
  // to delete all the completed todos
  const clearCompleted = () => {
    todos.map((todo) => {
      if (todo.completed) {
        const id = todo.id;
        deleteTodo(id);
      }
    });
  };
  return (
    <div>
      <form className="flex items-center bg-gray-100 px-4 py-4 rounded-md">
        <img src={note} className="w-6 h-6" alt="Add todo" />
        <input
          type="text"
          placeholder="Type your todo"
          className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <button
          type="submit"
          onClick={handleSubmit}
          className="appearance-none w-8 h-8 bg-no-repeat bg-contain"
        >
          <img src={plus} type="submit" alt="" />
        </button>
      </form>

      <ul className="flex justify-between my-4 text-xs text-gray-500">
        <li className="flex space-x-1 cursor-pointer">
          <img className="w-4 h-4" src={tick} alt="Complete" />
          <span onClick={handleCompleteAllTasks}>Complete All Tasks</span>
        </li>
        <li className="cursor-pointer" onClick={clearCompleted}>
          Clear completed
        </li>
      </ul>
    </div>
  );
}
